// ============================================================================
// Electronic Record and Signature Disclosure — shown at the consent gate at
// the top of the signing page, before the document is unlocked.
//
// CLEARED BY COUNSEL 2026-07-29 (confirmed by Ben). Decision Register DR-02
// is closed.
//
// The text covers the substantive points the federal ESIGN Act and state UETA
// adoptions expect a consumer disclosure to make: consent to electronic
// records, the right to request a paper copy, how to withdraw consent, how to
// update contact details, and the hardware/software needed to access the
// records.
//
// If this text changes, bump DISCLOSURE_VERSION here AND the matching
// ESIGN_DISCLOSURE_VERSION constant in supabase/functions/esign/shared.ts, so
// the audit trail keeps recording which wording each signer actually agreed
// to — and re-route the new wording to counsel.
// ============================================================================

export const DISCLOSURE_VERSION = 'TCS-ESIGN-DISCLOSURE-v1';

export const CONSENT_SUMMARY =
  'By continuing you agree to use electronic records and signatures for this document.';

export const CONSENT_CHECKBOX_LABEL =
  'I agree to use electronic records and signatures.';

export interface DisclosureSection {
  heading: string;
  body: string;
}

export const DISCLOSURE_SECTIONS: DisclosureSection[] = [
  {
    heading: 'Electronic delivery of records',
    body:
      'Terminal Cleaning Services LLC ("TCS") is providing this document to you ' +
      'electronically. By consenting, you agree that TCS may provide this document, ' +
      'and any related notices, disclosures and records, to you in electronic form ' +
      'rather than on paper, and that your electronic signature has the same legal ' +
      'effect as a handwritten signature.',
  },
  {
    heading: 'Your right to a paper copy',
    body:
      'You may request a paper copy of this document at no charge. Email ' +
      'contracts@terminalcleaning.com with the document name and the address the ' +
      'copy should be mailed to. Requesting a paper copy does not by itself ' +
      'withdraw your consent to receive records electronically.',
  },
  {
    heading: 'Withdrawing your consent',
    body:
      'You may withdraw your consent to receive records electronically at any time ' +
      'before you sign, by closing this page and emailing ' +
      'contracts@terminalcleaning.com. Withdrawing consent means TCS will not be ' +
      'able to complete this document electronically, and it may delay the ' +
      'agreement. Withdrawing consent has no effect on the validity of documents ' +
      'you already signed electronically.',
  },
  {
    heading: 'Keeping your contact details current',
    body:
      'TCS sends signing links and completed copies to the email address on file ' +
      'for you. If that address changes, tell your TCS contact or email ' +
      'contracts@terminalcleaning.com so records continue to reach you.',
  },
  {
    heading: 'What you need to access these records',
    body:
      'To view and keep these records you need a current web browser, an active ' +
      'email account, and the ability to open and save PDF files. Your signed copy ' +
      'is emailed to you and can be downloaded from the confirmation page.',
  },
  {
    heading: 'What is recorded',
    body:
      'To make this signature verifiable, TCS records the time you accepted this ' +
      'disclosure, the time you opened and signed the document, the IP address and ' +
      'browser you used, how you created your signature, and a fingerprint of the ' +
      'document you signed. These details appear on the Certificate of Completion ' +
      'attached to the signed document.',
  },
];
